module.exports = __webpack_public_path__ + "img/cloud.09d6e61d.png";